import { competitiveIntelligenceResearchTranslations } from './competitive-intelligence-research'
import { analyticsTranslations } from './analytics'

export const static_translation = {
  ...analyticsTranslations.German,
    "audience_access_available_audiences": "Verfügbare Zielgruppen",
    "audience_access_hcp": "Verfügbar für medizinisches Fachpersonal",
    "audience_access_partner": "Verfügbar für Partner",
    "audience_access_staff_us": "Verfügbar für US-Mitarbeitende",
    "audience_access_staff_global": "Verfügbar für globale Mitarbeitende",
  "upload_success": "Upload erfolgreich gesendet. Freigabe ausstehend.",
  "upload_title": "Formular zur Anforderung von Inhalts-Uploads",
  "context": 'Kontext',
  "mvu_essentials_register_welcome": "Welcome to MagVenture Universe Lite",
  "mvu_essentials_register_access_notice": "Access with this code is limited to a specific number of people. Thank you for not sharing it.",
  "portal_registration_participant_limit_reached": "Die Registrierung ist nicht verfügbar, da die maximale Teilnehmerzahl für diesen Zugang erreicht wurde. Bitte wenden Sie sich an die für Ihren MagVenture-Zugang zuständige Person.",
  "portal_registration_invite_invalid": "Dieser Einladungslink ist ungültig oder abgelaufen.",
  "lite_registration_success_title": "Registrierung abgeschlossen",
  "lite_registration_success_email_text": "Ihr Zugang zu MagVenture Universe Lite ist bereit. Wir haben Ihnen eine Willkommens-E-Mail mit dem Zugangslink gesendet. Melden Sie sich mit der gerade registrierten E-Mail-Adresse und Ihrem Passwort an.",
  "lite_registration_success_text": "Ihr Zugang zu MagVenture Universe Lite ist bereit. Melden Sie sich mit der gerade registrierten E-Mail-Adresse und Ihrem Passwort an.",
  "lite_registration_success_action": "Zur Lite-Anmeldung",
  "accelerator_registration_success_title": "Registrierung abgeschlossen",
  "accelerator_registration_success_email_text": "Ihr Zugang zum MagVenture Accelerator Program ist bereit. Wir haben Ihnen eine Willkommens-E-Mail mit dem Zugangslink gesendet. Melden Sie sich mit der gerade registrierten E-Mail-Adresse und Ihrem Passwort an.",
  "accelerator_registration_success_text": "Ihr Zugang zum MagVenture Accelerator Program ist bereit. Melden Sie sich mit der gerade registrierten E-Mail-Adresse und Ihrem Passwort an.",
  "accelerator_registration_success_action": "Zur Accelerator-Anmeldung",
  "describe_as_upload": "Bitte füllen Sie die folgenden Felder aus und laden Sie die Dateien hoch, die Sie als neue Inhalte für MagVenture Universe vorschlagen möchten. Unser Support-Team wird sich in wenigen Tagen mit Ihnen in Verbindung setzen, um Ihnen weitere Informationen zu Ihrer Anfrage zukommen zu lassen.",
  "title": "Titel",
  "table": "Inhaltstyp",
  "tags": "Tags",
  "tag-types": "Tag-Typen",
  "categories": "Kategorien",
  "sub-categories": "Unterkategorien",
  "document": "Dokument",
  "image": "Bild",

  "cancel": "Abbrechen",
  "send": "Senden",
  'share_link': 'Link teilen',
  'share_link_description': 'Jeder mit diesem Link kann {days} Tage lang auf diesen Inhalt zugreifen. Kopieren und teilen Sie ihn sicher.',
  'share_link_label': 'Diesen Link teilen:',
  'copy_link': 'Link kopieren',
  'copied': 'Kopiert!',
  'share_link_warning': 'Dieser Link läuft in {days} Tagen ab.',
  'share_link_duration': 'Gültigkeit (Tage)',
  'copy': 'Kopieren',
  "term_title": "Cookies- und Datenschutzrichtlinie",
  "register": "Registrieren",
  "login": "Anmelden",
  "email": "E-Mail",
  "registration_professional_email_hint": "Bitte verwenden Sie Ihre berufliche E-Mail-Adresse, z. B. name@ihreklinik.com.",
  "password": "Passwort",
  "signin": "Anmelden",
  "session_expired_sign_in_again": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an, um fortzufahren.",
  "reset_password": "Passwort zurücksetzen",
  "fill_the_field": "Feld ausfüllen",
  "success": "Vielen Dank!",
  "account_successfully_created": "Unser Team wird Ihre Anfrage prüfen und sich bei Rückfragen mit Ihnen in Verbindung setzen. Sobald Ihr Konto genehmigt wurde, erhalten Sie eine E-Mail mit den Zugangsdaten.",
  "close": "Schließen",
  "salutation": "Anrede",
  "first_name": "Vorname",
  "last_name": "Nachname",
  "company_name": "Firmenname",
  "job_title": "Berufsbezeichnung / Position",
  "industry": "Branche",
  "state": "Bundesland / Provinz",
  "zipcode": "Postleitzahl",
  "phone_number": "Telefonnummer",
  "password_confirmation": "Passwort bestätigen",
  "mr": "Herr",
  "mrs": "Frau",
  "ms": "Fr.",
  "signup": "Registrieren",
  "are_you_a_patient_or_a_therapist": "Sind Sie Patient oder Therapeut?",
  "create_your_password": "Erstellen Sie Ihr Passwort",
  "finish": "Fertigstellen",
  "create_your_account": "Konto erstellen",
  "back": "Zurück",
  "next": "Weiter",
  "create_a_password": "Ein Passwort erstellen",
  "enter_a_password_for_your_account": "Geben Sie ein Passwort für Ihr Konto ein",
  "subscribe_to_newsletter": "Ja, ich möchte gerne Bildungs-Updates, TMS-Ressourcen und Veranstaltungsinformationen von MagVenture erhalten.",
  "subscribe_to_newsletter_information": "Puedes darte de baja en cualquier momento. Respetamos tu perfil profesional y solo compartimos contenido relevante.",
  "i_accept_the": "Ich akzeptiere die",
  "i_accept_the_united": "Datenschutzrichtlinie",
  "privacy_policy": "Datenschutzrichtlinie",
  "send": "Senden",
  "back_to_login": "Zurück zur Anmeldung",
  "enter_your_email_to_recover_your_password": "Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort wiederherzustellen",
  "access_the_recovery_link_that_was_sent_to_your_email": "Rufen Sie den Wiederherstellungslink auf, der Ihnen per E-Mail gesendet wurde",
  "check_your_email": "Bitte prüfen Sie Ihre E-Mails",
  "new_password": "Neues Passwort",
  "confirm_new_password": "Neues Passwort bestätigen",
  "new_password_and_new_password_confirmation_are_not_the_same": "Neues Passwort und Bestätigung stimmen nicht überein",
  "password_changed_successfully": "Passwort erfolgreich geändert!",
  "create_a_new_password": "Neues Passwort erstellen",
  "enter_a_new_password_for_your_account": "Geben Sie ein neues Passwort für Ihr Konto ein",
  "save": "Speichern",
  "one_uppercase_letter": "Ein Großbuchstabe",
  "one_number": "Eine Zahl",
  "at_least_6_characters": "Mindestens 6 Zeichen",
  "at_least_1_special_character": "Mindestens 1 Sonderzeichen",
  "accept_terms": "Bedingungen akzeptieren",
  "password_and_password_confirmation_must_match": "Passwort und Bestätigung müssen übereinstimmen",
  "see_all": "Alle anzeigen",
  "watch_live_now": "Jetzt live ansehen",
  "courses_available_for_you": "Verfügbare Kurse für Sie",
  "partners-and-staffs_available_for_you": "Verfügbare Inhalte für Partners and Staff",
  "articles_available_for_you": "Verfügbare Artikel für Sie",
  "podcasts_available_for_you": "Verfügbare Podcasts für Sie",
  "documents_available_for_you": "Verfügbare Dokumente für Sie",
  "support-materials_available_for_you": "Verfügbare Praxisunterlagen für Sie",
  "marketing-materials_available_for_you": "Verfügbare Marketingmaterialien für Sie",
  "service-supports_available_for_you": "Service & Support für Sie verfügbar",
  "media-templates_available_for_you": "Verfügbare Social Media Vorlagen für Sie",
  "videos_available_for_you": "Verfügbare Videos für Sie",
  "photos_available_for_you": "Verfügbare Fotos für Sie",
  "courses": "Kurse",
  "partners-and-staffs": "Partners and Staff",
  "articles": "Artikel",
  "podcasts": "Podcasts",
  "documents": "Dokumente",
  "home": "Startseite",
  "favorites": "Favoriten",
  "no_favorites_message": "Sie haben noch keine Favoriten hinzugefugt.",
  "faq": "FAQ",
  "no_faqs_available": "Keine FAQs verfügbar.",
  "support": "Support",
  "contact_us": "Kontaktieren Sie uns",
  "my_account": "Mein Konto",
  "my_certificates": "Meine Zertifikate",
  "logout": "Abmelden",
  "search": "Suche",
  "frequently_asked_questions": "Häufig gestellte Fragen",
  "how_can_we_help_you": "Wie können wir Ihnen helfen?",
  "add_new_ticket": "Neues Ticket hinzufügen",
  "all_tickets": "Alle Tickets",
  "pending": "Ausstehend",
  "closed_tickets": "Geschlossene Tickets",
  "videos_and_contents": "Videos und Inhalte",
  "ticket_information": "Ticket-Informationen",
  "add_reply": "Antwort hinzufügen",
  "close_ticket": "Ticket schließen",
  "status": "Status",
  "ticket_id": "Ticket-ID",
  "created_date": "Erstellungsdatum",
  "category_department": "Kategorie / Abteilung",
  "give_feedback": "Feedback geben",
  "how_would_you_rate_the_way_this_request_was_handled": "Wie bewerten Sie die Bearbeitung Ihrer Anfrage?",
  "subject": "Betreff",
  "area_departament": "Bereich / Abteilung",
  "message": "Nachricht",
  "create_a_new_ticket": "Neues Ticket erstellen",
  "describe_as_soon_as_possible": "Beschreiben Sie Ihr Anliegen und wählen Sie die passende Abteilung, damit wir Ihnen so schnell wie möglich helfen können",
  "no_records_found": "Keine Einträge gefunden",
  "showing": "Angezeigt",
  "of": "von",
  "results": "Ergebnisse",
  "subject_title": "Betreff / Titel",
  "last_updated": "Zuletzt aktualisiert",
  "cancel": "Abbrechen",
  "registration_data": "Registrierungsdaten",
  "updated_successfully": "Erfolgreich aktualisiert",
  "created_successfully": "Erfolgreich erstellt",
  "edit": "Bearbeiten",
  "done": "Fertig",
  "filters": "Filter",
  "search.sections.trainingLearning": "Schulung und Lernen",
  "search.sections.documents": "Dokumente",
  "search.sections.images": "Bilder",
  "category": "Kategorie",
  "filter": "Filtern",
  "clear": "Zurücksetzen",
  "support_materials": "Praxisunterlagen",
  "marketing_materials": "Marketingmaterialien",
    "sales-support-materials": "Sales Support Materials",
    "sales-support-materials_available_for_you": "Sales Support Materials available for you",
    "sales_support_materials_empty": "No sales support materials are available yet.",
    "sales_support_materials_error": "We could not load the sales support materials. Please try again.",
    "sales_support_materials_unavailable": "Sales support materials are temporarily unavailable",
  "service-supports": "Service & Support",
  "service_support": "Service & Support",
  "support_videos": "Support Videos",
  "support_videos_empty": "Es sind noch keine Support-Videos verfügbar.",
  "support_videos_unavailable": "Support-Videos nicht verfügbar",
  "support_videos_error": "Die Support-Videos konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
  "support_video_unavailable": "Support-Video nicht verfügbar",
  "support_video_media_missing": "Video nicht verfügbar",
  "support_video_media_missing_description": "Für dieses Support-Video ist noch kein abspielbares Medium hinterlegt.",
  "support_video_about": "Über dieses Video",
  "media_templates": "Social Media Vorlagen",
  "videos": "Videos",
  "photos": "Fotos",
  "login_title": "Bitte melden Sie sich an",
  "login_title_essentials": "Bitte melden Sie sich bei MagVenture Universe Lite an",
  "accelerator_brand_name": "MagVenture",
  "accelerator_brand_program": "Accelerator Program",
  "login_title_accelerator": "Welcome to the MagVenture Accelerator Portal",
  "accelerator_welcome_intro": "This is your exclusive portal for everything you need to prepare for and participate in the MagVenture Accelerator.",
  "accelerator_welcome_details": "Here you’ll find clinical training focused specifically on Introduction to TMS, Major Depressive Disorder (MDD), and Obsessive Compulsive Disorder (OCD), along with materials and resources from the Accelerator program which will be posted after the program.",
  "accelerator_welcome_login": "Log in to access your training and Accelerator resources.",
  "welcome": "Willkommen! Dies ist Ihr persönliches Kundenportal für klinische Schulungen, Marketingmaterialien und Medienressourcen – einschließlich Videos, Behandlungsfotos und Vorlagen für soziale Medien. Melden Sie sich an, um auf individuell zugeschnittene Tools zuzugreifen, die Ihren Erfolg mit MagVenture TMS unterstützen.",
  "existing_users": "Bestehende Nutzer",
  "enter_credentials_to_continue": "Geben Sie Ihre Zugangsdaten ein, um fortzufahren.",
  "new_users": "Neue Nutzer",
  "register_link_text": "Registrieren",
  "register_and_gain_access_part1": "Noch kein Konto? Gehen Sie zu ",
  "register_and_gain_access_part2": " und erhalten Sie vollen Zugang zu unserer exklusiven Lern- und Ressourcenplattform.",
  "contact": "Kontaktieren Sie uns",
  "contact.topicCategory": "Wählen Sie eine Themenkategorie",
  "contact.topicCategory.label": "Themenkategorie",
  "contact.chooseSubject": "Wählen Sie das Thema, das Ihrer Anfrage am ehesten entspricht.",
  "contact.message": "Nachricht",
  "contact.message.label": "Nachricht",
  "contact.describeIssue": "Beschreiben Sie Ihr Anliegen im Detail. Unser Team wird sich so schnell wie möglich bei Ihnen melden.",
  "contact.fileAttachment": "Datei anhängen",
  "contact.fileAttachment.label": "Dateianhang",
  "contact.attachmentHelp": "Optional können Sie einen Screenshot oder eine Datei anhängen (z. B. JPG, PNG, PDF, DOC)",
  "contact.preferredContact": "Bevorzugte Kontaktmethode",
  "contact.preferredContact.label": "Bevorzugte Kontaktmethode",
  "contact.contactPreference": "Wie möchten Sie bezüglich Ihres Anliegens kontaktiert werden?",
  "contact.maximum_characters": "Maximal: 1000 Zeichen",
  "contact.email.label": "E-Mail",
  "contact.phone.label": "Telefon",
  "contact.technical_support": "Technischer Support",
  "contact.questions_about_products": "Fragen zu Produkten / Dienstleistungen",
  "contact.access_issues": "Zugriffsprobleme",
  "contact.suggestion": "Vorschlag",
  "contact.other": "Sonstiges",
  "contact.file": "Dateien auswählen",
  "contact.submit": "Absenden",
  "contact.is_required": "ist erforderlich",
  "contact.success": "Kontakt erfolgreich gesendet",
  "register.undertems": "Der Zugang zu MagVenture Universe unterliegt einer Prüfung und Genehmigung. Die Freischaltung kann bis zu 2 Werktage dauern.",
  "courses-webnars-trainning": "Kurse, Webinare und Schulungen",
  "usshop": "US Shop",
  "notifications": "Benachrichtigungen",
  "unread_notifications": "ungelesene Benachrichtigungen",
  "unread_notification": "ungelesene Benachrichtigung",
  "unread": "Ungelesen",
  "mark_all_notifications_read": "Alle als gelesen markieren",
  "notifications_update_error": "Benachrichtigungen konnten nicht aktualisiert werden.",
  "try_again": "Erneut versuchen",
  "notifications_load_error": "Benachrichtigungen konnten nicht geladen werden",
  "notifications_load_error_description": "Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  "notifications_empty": "Noch keine Benachrichtigungen",
  "notifications_empty_description": "Aktualisierungen und wichtige Aktivitäten werden hier angezeigt.",
  "notification_not_found": "Benachrichtigung nicht gefunden",
  "notification_not_found_description": "Diese Benachrichtigung ist nicht mehr verfügbar oder Sie haben keinen Zugriff darauf.",
  "back_to_notifications": "Zurück zu den Benachrichtigungen",
  "open_notification": "Öffnen",
  "loading_notifications": "Benachrichtigungen werden geladen",
  "loading_notification": "Benachrichtigung wird geladen",
  "notifications_subtitle": "Aktualisierungen, neue Kurse und wichtige Aktivitäten an einem Ort.",
  "recent_activity": "Letzte Aktivitäten",
  "notifications_all_read": "Alles auf dem neuesten Stand",
  "staff_essentials_invites_title_required": "Titel ist erforderlich.",
  "staff_essentials_invites_updated": "Einladung aktualisiert.",
  "staff_essentials_invites_created": "Einladung erstellt.",
  "staff_essentials_invites_link_unavailable": "Der Einladungslink ist nicht verfügbar.",
  "staff_essentials_invites_link_copied": "Einladungslink kopiert.",
  "staff_essentials_invites_copy_prompt": "Diesen Einladungslink kopieren:",
  "staff_essentials_invites_eyebrow": "MagVenture Universe",
  "staff_essentials_invites_menu_title": "MVU Lite Invitations",
  "staff_essentials_invites_title": "MVU Lite Invitations",
  "staff_essentials_invites_subtitle": "Erstellen Sie Einladungslinks für MagVenture Universe Lite und verfolgen Sie, wie viele Registrierungen jeder Link verwendet hat.",
  "staff_essentials_invites_refresh": "Aktualisieren",
  "staff_essentials_invites_create": "Einladung erstellen",
  "staff_essentials_invites_total": "Einladungen gesamt",
  "staff_essentials_invites_active": "Aktiv",
  "staff_essentials_invites_registrations": "Registrierungen",
  "staff_essentials_invites_remaining": "Verbleibend",
  "staff_essentials_invites_links": "Einladungslinks",
  "staff_essentials_invites_found_singular": "Einladung gefunden",
  "staff_essentials_invites_found_plural": "Einladungen gefunden",
  "staff_essentials_invites_none_created": "Noch keine Einladungslinks erstellt",
  "staff_essentials_invites_syncing": "Synchronisierung",
  "staff_essentials_invites_live_data": "Live-Daten",
  "staff_essentials_invites_loading_links": "Einladungslinks werden geladen...",
  "staff_essentials_invites_column_title": "Titel",
  "staff_essentials_invites_column_link": "Link",
  "staff_essentials_invites_column_status": "Status",
  "staff_essentials_invites_column_used": "Verwendet",
  "staff_essentials_invites_column_remaining": "Verbleibend",
  "staff_essentials_invites_column_expires": "Läuft ab",
  "staff_essentials_invites_column_created": "Erstellt",
  "staff_essentials_invites_column_actions": "Aktionen",
  "staff_essentials_invites_active_status": "Aktiv",
  "staff_essentials_invites_inactive_status": "Inaktiv",
  "staff_essentials_invites_unlimited": "Unbegrenzt",
  "staff_essentials_invites_copy_link": "Link kopieren",
  "staff_essentials_invites_history": "Verlauf",
  "staff_essentials_invites_edit": "Bearbeiten",
  "staff_essentials_invites_empty_title": "Noch keine Lite-Einladungen",
  "staff_essentials_invites_empty_description": "Erstellen Sie den ersten Einladungslink, um Registrierungen zu verfolgen.",
  "staff_essentials_invites_edit_modal": "Einladung bearbeiten",
  "staff_essentials_invites_create_modal": "Einladung erstellen",
  "staff_essentials_invites_generated_by_strapi": "Der Einladungscode und der öffentliche Link werden von Strapi generiert.",
  "staff_essentials_invites_field_title": "Titel",
  "staff_essentials_invites_field_maximum_uses": "No. of users having access to this invitation",
  "staff_essentials_invites_field_expires_at": "Läuft ab am",
  "staff_essentials_invites_history_modal": "Einladungsverlauf",
  "staff_essentials_invites_loading_history": "Verlauf wird geladen...",
  "staff_essentials_invites_no_institution": "Keine Institution",
  "staff_essentials_invites_no_registrations": "Noch keine Registrierungen für diese Einladung.",
  "staff_essentials_invites_locked_content_title": "Inhaltszugriff",
  "lite_invite_default_content_help": "Alle für Lite konfigurierten Inhalte sind standardmäßig verfügbar. Passen Sie den Zugriff in den erweiterten Optionen an.",
  "staff_essentials_invites_locked_content_description": "Markierte Inhalte sind für Benutzer verfügbar, die sich mit dieser Einladung registrieren. Entfernen Sie die Markierung, um den Zugriff zu sperren.",
  "staff_essentials_invites_locked_content_selected": "mit Zugriff",
  "staff_essentials_invites_locked_content_select_visible": "Sichtbare Ergebnisse freigeben",
  "staff_essentials_invites_locked_content_clear": "Alle Inhalte sperren",
  "staff_essentials_invites_locked_content_search": "Search Lite content",
  "staff_essentials_invites_locked_content_filter": "Content type",
  "staff_essentials_invites_locked_content_all_types": "All types",
  "staff_essentials_invites_locked_content_loading": "Loading catalog...",
  "staff_essentials_invites_locked_content_empty": "No matching content.",
  "staff_essentials_invites_locked_content_error": "Could not load the Lite catalog.",
  "staff_essentials_invites_content_preset_title": "Inhaltsvorgabe",
  "staff_essentials_invites_content_preset_description": "Wählen Sie eine oder mehrere Gruppen, um die aktuelle Auswahl durch deren kombinierte Inhalte zu ersetzen. Passen Sie anschließend die einzelnen Inhalte unten an.",
  "staff_essentials_invites_content_preset_placeholder": "Vordefinierte Inhaltsgruppe",
  "staff_essentials_invites_content_preset_custom": "Benutzerdefinierte Auswahl (keine Vorgabe)",
  "staff_essentials_invites_content_preset_loading": "Inhaltsvorgaben werden geladen...",
  "staff_essentials_invites_content_preset_error": "Die Inhaltsvorgaben konnten nicht geladen werden.",
  "staff_essentials_invites_content_preset_empty": "Keine aktiven Vorgaben verfügbar. Inhalte können weiterhin manuell ausgewählt werden.",
  "staff_essentials_invites_content_preset_applied": "Vorgabe angewendet",
  "staff_essentials_invites_content_preset_applied_description": "Diese Inhalte wurden in die Einladung kopiert. Änderungen unten verändern die Strapi-Gruppe nicht.",
  "exclusive_content_title": "Exclusive content",
  "exclusive_content_message": "This content is exclusive to MagVenture clients.",
  "survey_load_error": "Diese Umfrage konnte nicht geladen werden.",
  "survey_unavailable": "Umfrage nicht verfügbar",
  "survey_back_to_course": "Zurück zum Kurs",
  "survey_thank_you": "Vielen Dank für Ihr Feedback",
  "survey_completed_description": "Ihre Antworten wurden gespeichert. Sie können mit dem Kurs fortfahren.",
  "survey_submitted": "Gesendet",
  "survey_continue_course": "Kurs fortsetzen",
  "survey_course_feedback": "Kursfeedback",
  "survey_intro_description": "Beantworten Sie die folgenden Fragen zu Ihrer Schulungserfahrung.",
  "survey_questions": "Fragen",
  "survey_minutes": "Minuten",
  "survey_account_linked": "In Ihrem Konto gespeichert",
  "survey_start": "Umfrage starten",
  "survey_progress": "Umfragefortschritt",
  "survey_optional": "Optional",
  "survey_required": "Erforderlich",
  "survey_text_placeholder": "Geben Sie hier Ihre Antwort ein...",
  "survey_back": "Zurück",
  "survey_submit": "Feedback senden",
  "survey_continue": "Weiter",
  "survey_required_answer": "Diese Frage ist erforderlich.",
  "survey_required_before_quiz": "Schließen Sie die erforderliche Umfrage ab, bevor Sie dieses Quiz starten.",
  "survey_required_title": "Umfrage erforderlich",
  "survey_open": "Umfrage öffnen",
  "survey_completed_action": "Umfrage abgeschlossen",
  "survey_complete_required": "Erforderliche Umfrage abschließen",
  "survey_course_completed": "Kurs abgeschlossen",
  "survey_next_step": "Nächster Schritt",
  "survey_share_experience": "Teilen Sie Ihre Erfahrung",
  "survey_opens_in": "Umfrage wird geöffnet in",
  "survey_seconds": "Sekunden",
  "survey_answer_now": "Umfrage beantworten",
  "survey_stay_here": "Hier bleiben",
  "user_approvals_menu_title": "Benutzerfreigaben",
  "user_approvals_eyebrow": "Zugriffsverwaltung",
  "user_approvals_title": "Benutzerfreigaben",
  "user_approvals_subtitle": "Prüfen Sie ausstehende Zugriffsanfragen in Ihrem Freigabebereich.",
  "user_approvals_pending_count": "ausstehend",
  "user_approvals_refresh": "Aktualisieren",
  "user_approvals_pending_requests": "Ausstehende Anfragen",
  "user_approvals_search_placeholder": "Nach Name, E-Mail oder Unternehmen suchen",
  "user_approvals_unavailable": "Freigaben nicht verfügbar",
  "user_approvals_auth_required": "Melden Sie sich an, um die Anfragen aufzurufen.",
  "user_approvals_not_authorized": "Mit diesem Konto ist kein aktiver Freigabeempfänger verknüpft.",
  "user_approvals_network_error": "Netzwerkfehler. Bitte versuchen Sie es erneut.",
  "user_approvals_load_error": "Die Freigabeanfragen konnten nicht geladen werden.",
  "user_approvals_empty": "Es gibt keine ausstehenden Freigaben.",
  "user_approvals_empty_description": "Neue Anfragen für Ihren Bereich werden hier angezeigt.",
  "user_approvals_no_search_results": "Keine passenden Freigaben",
  "user_approvals_no_search_results_description": "Versuchen Sie einen anderen Namen, eine E-Mail oder ein Unternehmen.",
  "user_approvals_created_at": "Erstellt am",
  "user_approvals_name": "Name",
  "user_approvals_email": "E-Mail",
  "user_approvals_company": "Unternehmen",
  "user_approvals_country": "Land",
  "user_approvals_region": "Region",
  "user_approvals_location": "Standort",
  "user_approvals_status": "Status",
  "user_approvals_actions": "Aktionen",
  "user_approvals_approved": "Genehmigt",
  "user_approvals_rejected": "Abgelehnt",
  "user_approvals_approve": "Genehmigen",
  "user_approvals_reject": "Ablehnen",
  "user_approvals_already_processed": "Diese Freigabeanfrage wurde bereits bearbeitet.",
  "user_approvals_process_error": "Diese Freigabeanfrage konnte nicht bearbeitet werden.",
  "user_approvals_approve_success": "Benutzer erfolgreich genehmigt.",
  "user_approvals_reject_success": "Benutzer erfolgreich abgelehnt.",
  "user_approvals_manual_review_required": "Manuelle Prüfung erforderlich",
  "user_approvals_company_informed": "Bei der Registrierung angegebenes Unternehmen",
  "user_approvals_phone": "Telefon",
  "user_approvals_customer_select": "Kunde / Klinik",
  "user_approvals_search_companies": "Kunde oder Klinik suchen",
  "user_approvals_no_companies": "Kein passender Kunde oder keine Klinik gefunden",
  "user_approvals_company_load_error": "Kunden oder Kliniken konnten nicht geladen werden.",
  "user_approvals_confirm_title": "Benutzer genehmigen",
  "user_approvals_confirm_description": "Prüfen Sie die Registrierung und bestätigen Sie den Kunden vor der Freigabe.",
  "user_approvals_association_confirmation": "Dieser Benutzer wird zugeordnet zu:",
  "user_approvals_confirm_approval": "Freigabe bestätigen",
  "mag.title": "Maggie",
  "mag.subtitle": "Your learning companion",
  "mag.preview_badge": "Preview",
  "mag.open_aria": "Open Maggie assistant",
  "mag.close_aria": "Close Maggie assistant",
  "mag.launcher_tooltip": "Talk to Maggie",
  "mag.intro_title": "Hi! I'm Maggie.",
  "mag.intro_body": "How can I help?",
  "mag.dismiss_intro_aria": "Dismiss Maggie introduction",
    "mag.welcome": "Hallo! Ich bin Maggie. Was möchtest du heute entdecken?",
    "mag.welcome_named": "Hallo, {name}! Ich bin Maggie. Was möchtest du heute entdecken?",
  "mag.quick_actions_label": "Try asking",
  "mag.quick.find_course": "Find a course",
  "mag.quick.explore_trails": "Explore Learning Paths",
  "mag.quick.continue_learning": "Continue learning",
  "mag.quick.product_tutorials": "Find product tutorials",
  "mag.quick.about_magventure": "Learn how MagVenture works",
  "mag.placeholder": "Ask Maggie a question...",
  "mag.composer_label": "Message to Maggie",
  "mag.send_aria": "Send message to Maggie",
  "mag.preview_response": "Ich kann mit der MagVenture-Lernbibliothek antworten.",
  "mag.local_error": "Maggie konnte keine Antwort vorbereiten. Bitte versuchen Sie es erneut.",
  "mag.typing": "Maggie bereitet eine Antwort vor",
  "mag.you_label": "Your message",
  "mag.mag_label": "Message from Maggie",
  "mag.avatar_fallback": "Maggie avatar fallback",
  "mag.loading": "Opening Maggie...",
    "mag.sources": "Quellen",
    "mag.page": "Seite",
  "mag.feedback_question": "War das hilfreich?",
  "mag.feedback_up": "Hilfreiche Antwort",
  "mag.feedback_down": "Nicht hilfreiche Antwort",
  "mag.feedback_thanks": "Danke für Ihr Feedback.",
  "mag.feedback_error": "Feedback konnte nicht gesendet werden.",
    "mag.feedback_form.title": "Feedback teilen",
    "mag.feedback_form.open": "Hier klicken, um Feedback zu teilen",
    "staff_essentials_invites_content_locked": "Gesperrt",
    "staff_essentials_invites_content_available": "Zugriff gewährt",
    "mag.feedback_form.description": "Your feedback will be saved in our internal inbox for the MagVenture team to review. Up to 4,000 characters.",
    "mag.feedback_form.placeholder": "Your feedback",
    "mag.feedback_form.submit": "Submit feedback",
    "mag.feedback_form.cancel": "Back to chat",
    "mag.competitor_feedback.prompt": "Hallo! Ich helfe dir, den Competitive Hub zu erkunden. Was möchtest du wissen? Über den Feedback-Button unten kannst du auch einen Vorschlag senden.",
    "mag.competitor_feedback.prompt_named": "Hallo, {name}! Ich helfe dir, den Competitive Hub zu erkunden. Was möchtest du wissen? Über den Feedback-Button unten kannst du auch einen Vorschlag senden.",
  "mag.competitor_feedback.placeholder": "Share your Competitor Hub feedback...",
    "mag.competitor_feedback.success": "Thank you! Your feedback has been saved for our team to review.",
    "mag.competitor_feedback.error": "Your feedback could not be saved. Your message is still in the form; please try again.",
  "mag.feedback_reason.not_helpful": "Nicht hilfreich",
  "mag.feedback_reason.wrong_source": "Falsche Quelle",
  "mag.feedback_reason.unclear": "Unklar",
  "mag.feedback_reason.too_general": "Zu allgemein",
  "mag.feedback_reason.unsafe": "Unsicher",
  "competitive_intelligence_menu_title": "Competitive Intelligence",
  "competitive_intelligence_eyebrow": "Marktinformationen",
  "competitive_intelligence_title": "Competitive Intelligence",
  "competitive_intelligence_description": "Ein aktueller Überblick über Wettbewerbsforschung, Marktsignale und von MagVenture beobachtete soziale Quellen.",
  "competitive_intelligence_freshness_unknown": "Aktualisierungszeit nicht verfügbar",
  "competitive_intelligence_overview_heading": "Intelligence-Übersicht",
  "competitive_intelligence_metric_competitors": "Beobachtete Wettbewerber",
  "competitive_intelligence_metric_research": "Forschungsdatensätze",
  "competitive_intelligence_metric_market": "Marktsignale",
  "competitive_intelligence_metric_social": "Social-Media-Beiträge",
  "competitive_intelligence_sources_title": "Forschungsquellen",
  "competitive_intelligence_sources_description": "Abdeckung und Aktualität der aktuellen Competitive-Intelligence-Datenbank.",
  "competitive_intelligence_records": "Datensätze",
  "competitive_intelligence_sources_empty": "Noch keine Details auf Quellenebene verfügbar.",
  "competitive_intelligence_loading": "Competitive-Intelligence-Übersicht wird geladen",
  "competitive_intelligence_empty_title": "Noch keine Intelligence-Daten",
  "competitive_intelligence_empty_description": "Die Datenpipeline hat noch keine Datensätze für diese Übersicht veröffentlicht.",
  "competitive_intelligence_denied_title": "Zugriff nicht verfügbar",
  "competitive_intelligence_denied_description": "Ihr Konto hat keinen Zugriff auf Competitive Intelligence.",
  "competitive_intelligence_unavailable_title": "Competitive Intelligence ist nicht verfügbar",
  "competitive_intelligence_unavailable_description": "Der Dienst ist derzeit nicht erreichbar. Bitte versuchen Sie es gleich erneut.",
  "competitive_intelligence_error_title": "Übersicht konnte nicht geladen werden",
  "competitive_intelligence_error_description": "Eine unerwartete Antwort hat das Laden dieser Übersicht verhindert.",
  ...competitiveIntelligenceResearchTranslations.German
}
